<template>
  <div class="p-2">
    <h4>
      Total: {{ ordersQuantity }} commande{{ ordersQuantity > 1 ? "s" : "" }}.
    </h4>

    <div v-if="data.ratioPercentage" class="mt-2">
      <h5>
        Le département a généré {{ data.ratioPercentage.toFixed(2) }}% du CA
      </h5>
    </div>

    <div v-if="data.totalTurnover" class="mt-1">
      <p class="label" style="background-color: #4caf50">
        Total: {{ data.totalTurnover / 100 }} €
      </p>
    </div>

    <div v-if="data.totalTurnoverPayed">
      <p class="label" :style="`background-color: ${colors.orderStatus}`">
        Payé: {{ data.totalTurnoverPayed / 100 }} €
      </p>
    </div>

    <div v-if="data.totalTurnoverPartial">
      <p class="label" :style="`background-color: ${colors.orderStatus}`">
        Partiel: {{ data.totalTurnoverPartial / 100 }} €
      </p>
    </div>

    <div v-if="data.totalRefunded">
      <p class="label" :style="`background-color: ${colors.orderStatus}`">
        Remboursé: {{ data.totalRefunded / 100 }} €
      </p>
    </div>

    <div v-if="data.totalComp">
      <p class="label" :style="`background-color: ${colors.merchants}`">
        Just Coaching Company: {{ data.totalComp / 100 }} €
      </p>
    </div>

    <div v-if="data.totalCorp">
      <p class="label" :style="`background-color: ${colors.merchants}`">
        Just Coaching Corporate: {{ data.totalCorp / 100 }} €
      </p>
    </div>

    <div v-if="data.totalB2C">
      <p class="label" :style="`background-color: ${colors.clientType}`">
        B2C: {{ data.totalB2C / 100 }} €
      </p>
    </div>

    <div v-if="data.totalB2B">
      <p class="label" :style="`background-color: ${colors.clientType}`">
        B2B: {{ data.totalB2B / 100 }} €
      </p>
    </div>

    <div v-for="concept in data.concepts" :key="concept.name">
      <p class="label" :style="`background-color: ${colors.concepts}`">
        {{ concept.name }}: {{ concept.totalTurnover / 100 }} €
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Object, required: true },
    ordersQuantity: { type: Number, required: true },
  },

  data() {
    return {
      colors: {
        orderStatus: "#f78c40",
        clientType: "#ffc107",
        merchants: "#2196f3",
        concepts: "#607d8b",
      },
    };
  },
};
</script>

<style>
.label {
  display: inline-block;
  border-radius: 100px;
  padding: 3px 20px;
  word-break: break-word;
  color: white;
}
</style>
